import React, { useState } from "react"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import IconButton from "@material-ui/core/IconButton"
import MenuIcon from "@material-ui/icons/Menu"
import AccountCircleIcon from "@material-ui/icons/AccountCircle"
import MenuItem from "@material-ui/core/MenuItem"
import Menu from "@material-ui/core/Menu"
import clsx from "clsx"

import { Link } from "@material-ui/core"
import { APP_NAME, AUTH_URL } from "../../../constants"
import AuthenticationUtil from "../utils/AuthenticationUtil"
import useStyles from "../layouts/styles/privateCss"
import AppSelection from "./AppSelection"

const Header = props => {
  const { user, handleShowLeftNav } = props
  const classes = useStyles(props)
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleMenu = e => setAnchorEl(e.currentTarget)
  const handleClose = () => setAnchorEl(null)
  const handleLogout = () => AuthenticationUtil.logout()
  //const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  return (
    <AppBar position="absolute" elevation={1} className={classes.appBar}>
      <Toolbar className={classes.toolbar} >
        <IconButton
          color="inherit"
          aria-label="Open drawer"
          onClick={() => {
            handleShowLeftNav()
          }}
          edge="start"
          className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
        >
          <MenuIcon style={{ color: "#000000" }}/>
        </IconButton>
          <Link to="/" style={{ textDecoration: "none", color: "white", flexGrow: 1 }}>
          <Typography
            component="h1"
            variant="h6"
            noWrap
            className={classes.title}
          >
            <span className={classes.appName}>{APP_NAME}</span>
          </Typography>
        </Link>

        <AppSelection user={user} /> &nbsp;&nbsp;&nbsp;
        
          <Typography component="h1" variant="h6" 
            align="right"
            noWrap style={{color:'#000000'}}
          >
            {user.username}
          </Typography> 
        <IconButton style={{color:'#000000'}} onClick={handleMenu}>
          <AccountCircleIcon />
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={open}
          onClose={handleClose}
        >
          <MenuItem
            component={Link}
            target="_blank"
            href={`${AUTH_URL}/profile/?refUrl=${window.location.href}&appName=${APP_NAME}`}
            color="inherit"
          >
            Manage account
          </MenuItem>
          <MenuItem onClick={() => handleLogout()}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  )
}

export default Header
